export default {
    common: {
        noData: 'ログイン',
        copy: 'メールアドレス/ユーザー名を入力してください',
        copySuccess: 'パスワードを入力してください',
        confirmText: 'ログイン',
        cancelText: 'パスワードを忘れた',
        sendSuccess: 'アカウントを登録',
        qrCodeDownloadApp: 'スキャンコードダウンロードApp'
    },
    login: {
        title: 'ログイン',
        enterUserName: 'メールアドレス/ユーザー名を入力してください',
        enterPassword: 'パスワードを入力してください',
        enterLogin: 'ログイン',
        forgotPassword: 'パスワードを忘れた',
        register: 'アカウントを登録',
    },
    register: {
        title: '登録する',
        enterUserName: 'ユーザー名',
        enterPassword: 'パスワード',
        enterEmail: 'メール',
        enterCode: 'メール認証コード',
        inviteCode: '招待コード（オプション）',
        sendEmailCode: '確認コードを送信',
        enterUserNameErr: 'ユーザー名を入力してください',
        enterUserNameErr2: 'ユーザー名は 6 ～ 16 文字の文字または数字で構成されています',
        enterPasswordErr: 'パスワードを入力してください、',
        enterPasswordErr2: 'パスワードは8～18文字の英字、数字、特殊記号で構成されています',
        enterEmailErr: 'メールアドレスを入力してください',
        enterEmailErr2: '正しいメールアドレスを入力してください',
        enterCodeErr: 'メール認証コードを入力してください',
        enterRegister: '登録する',
        registerSuccess: '登録が成功しました。ログイン ページにリダイレクトされます...',
        toLogin: 'すでにアカウントをお持ちですか?直接ログインしてください',
        emailCodeTip: '受信箱にメールが届かない場合は、迷惑メールとして誤って認識されている可能性がございますので、迷惑メールフォルダをご確認ください。'
    },
    forgotPassword: {
        title: 'パスワードを忘れた',
        enterEmail: 'メール',
        enterCode: 'メール認証コード',
        sendEmailCode: '確認コードを送信',
        enterEmailErr: 'メールアドレスを入力してください',
        enterEmailErr2: '正しいメールアドレスを入力してください',
        enterCodeErr: 'メール認証コードを入力してください',
        enterPassword: '新しいパスワード',
        enterPasswordErr: '新しいパスワードを入力してください',
        enterPasswordErr2: 'パスワードは8～18文字の英字、数字、特殊記号で構成されています',
        enterBtn1: 'キャンセル',
        enterBtn2: '確認する',
        forgotPasswordSuccess: '変更が成功しました。ログイン ページにリダイレクトされます...'
    },
    layoutHeader: {
        login: 'ログイン',
        register: '登録する',
        nav: ['引用', 'プラットフォーム', 'パブリックチェーン', '碑文', '清算', 'スマートマネー', '長短', '大口', 'レート', 'ニュース', 'アプリケーション'],
        navHyperliquid: 'Hyperliquidクジラ監視',
        userNav1: 'サインイン',
        userNav12: 'ウォレットの詳細',
        userNav2: 'コインを引き出す',
        userNav13: '貨幣引出記録',
        userNav3: '契約書チェック',
        userNav4: '招待リンク',
        userNav5: '集める',
        userNav6: '追跡',
        userNav7: 'チーム',
        userNav8: '道具',
        userNav9: 'やめる',
        userNav10: 'バインドAPI',
        userNav11: '新しいロボットを作る',
        searchPlaceholder: '住所または通貨のクエリ',
        historyTitle: '履歴検索履歴',
        searchTitle1: '契約',
        searchTitle2: '通貨',
        searchList1_1: '名前',
        searchList1_2: 'オンチェーンのトランザクション量',
        searchList1_3: '価格',
        searchList2_1: '名前',
        searchList2_2: '循環量',
        searchList2_3: '価格',
        searchNoResult: 'まだ検索結果がありません',
    },
    layoutTop: {
        topTitle1: '主流の通貨市場リファレンス',
        topTitle2: 'センチメントインジケーター',
        sentimentIndexBlock1: 'センチメントインデックス',
        sentimentIndexBlock1_1: '極度のパニック',
        sentimentIndexBlock1_2: 'パニック',
        sentimentIndexBlock1_3: '中性',
        sentimentIndexBlock1_4: 'よく深い',
        sentimentIndexBlock1_5: '極度の貪欲さ',
        sentimentIndexBlock2: 'BTC ポジションのロングとショート',
        sentimentIndexBlock2_1: '強気の優位性',
        sentimentIndexBlock2_2: 'ショートアドバンテージ',
        trend24h: '24時間の推移',
        past24h: '過去24時間',
        candleSummary: 'BTC終値：直近48本の30分足',
        chartLoading: 'チャートを読み込み中…',
        chartUnavailable: 'チャートデータを取得できません',
        sentimentDetails: '詳細を見る',
        sentimentUnavailable: 'データなし',
        btcRatio: 'BTCロングショート',
        ratioShare: 'ロング {long}% · ショート {short}%',
        moodHistory: '過去の指数',
        moodRecentDays: '直近 {count} 日',
        moodVsYesterday: '前日比 {value}',
        moodUnchanged: '前日と同じ',
    },
    layoutSection: {
        title1: '賢いお金',
        title2: '補助ツール',
        titleMore: 'もっと>>',
    },
    layoutFooter: {
        appTitle: 'ダウンロードするアプリが多すぎます',
        appNav1: '応用',
        appNav2: '財布',
        appNav3: '社会的接触',
        explain1: '免責事項:',
        explain2: 'このウェブサイトのすべてのコンテンツは,サードパーティのプラットフォームから提供されており,ウェブサイト上のすべてのブロックチェーン関連のデータおよび資料は,ユーザーの学習および研究のみを目的としており,いかなる種類の保証も行いません。他の分野への投資や法的提案や根拠を構成するものではありません。関連するデータとコンテンツは注意して使用し,発生するすべてのリスクを負担する必要があります。コンテンツについて独自の調査,レビュー,分析,検証を行うことを強くお勧めします。 ',
        copyright: '2026 - 最終的な解釈権は TokenTrend に帰属します'
    },
    coinDetails: {
        titleLabel1: '24時間の価格上昇または下落',
        titleLabel2: '24時間以内の最高値',
        titleLabel3: '24時間最低価格',
        titleLabel4: '取引高',
        titleLabel5: 'レポートのボリューム',
        titleLabel6: '史上最高値',
        titleLabel7: '史上最低価格',
        infoItem1: '通貨：',
        infoItem2: '公式ウェブサイトのリンク:',
        infoItem3: '24H最高価格:',
        infoItem4: '24H最底価格:',
        infoItem5: '流通量:',
        infoItem6: '発行総額:',
        infoItem7: '最大発行部数:',
        infoItem8: '市場投入までの時間:',
        infoItem9: '価格開始時間:',
        infoItem10: 'ホワイトペーパーのリンク:',
    },
    newCoinDetails: {
        titleLabel0: '直接リンク:',
        titleLabel1: '循環',
        titleLabel2: '循環率',
        titleLabel3: '販売数量',
        titleLabel4: '発行総額',
        titleLabel5: '24時間増加',
        titleLabel6: '最新の価格',
        titleLabel7: 'オファー価格',
        titleLabel8: '先行販売時間',
        titleLabel9: 'コイン上場プラットフォーム',
        titleLabel10: '売上高に占める割合',
        listTitle: '市況',
        list1: '取引プラットフォーム',
        list2: 'コインペア',
        list3: '24時間取引高',
        list4: '24H トランザクション量 ($)',
        list5: '割合',
    },
    platformDetails: {
        title: 'プラットフォームの詳細',
        website: '公式ウェブサイト:',
        volumn24h: '24H トランザクション量:',
        riseFall24h: '24 時間の増減:',
        synopsis: '導入',
        content1: '確立時間',
        content2: '登録地',
        content3: 'KYC検証',
        content4: '量子化インターフェイス',
        content5: '資産',
        content6: '取引ペアの数量',
        isTrue: 'はい',
        isFalse: 'いいえ',
        lastLinkTitle1: 'トランザクションサポート',
        lastLinkTitle2: '関連リンク',
        content8: '現物取引',
        content9: '契約取引',
        content10: 'OTC',
        content11: '法定通貨取引',
        title3: '関連リンク',
        content12: 'フェイスブック',
        content13: 'ツイッター',
        content14: 'レディット',
        content15: '電報',
    },
    firmOffer: {
        titleLabel0: '契約アドレス：',
        titleLabel1: '保有アドレス数',
        titleLabel2: '独立した取引アドレス数',
        titleLabel3: '取引回数',
        titleLabel4: '取引額',
        titleLabel5: '流動性',
        titleLabel6: '時価総額',
        titleLabel7: '作成日時',
        titleLabel8: 'ロックされた時価総額',
        tabs1: '取引履歴',
        tabs2: 'プールの変動',
        tabs3: '保有アドレス',
        tabs4: '私のポジション',
        transactionTh1: '時間',
        transactionTh2: 'タイプ',
        transactionTh3: '数量',
        transactionTh4: '価格',
        transactionTh5: '総価値',
        transactionTh6: 'ユーザーアドレス',
        transactionTh7: '取引ハッシュ',
        tag1: '買い',
        tag2: '売り',
        tag3: '追加',
        tag4: '減少',
        poolTip: 'デフォルトで最初のプールデータが表示されます',
        poolTh1: '時間',
        poolTh2: 'タイプ',
        poolTh3: '数量/トークン',
        poolTh4: '総価値',
        poolTh5: 'ユーザーアドレス',
        poolTh6: '取引ハッシュ',
        poolCurrent: '保有アドレス数',
        Explain1: '保有アドレス数:',
        Explain2: '上位10の割合:',
        Explain3: 'スナイパー数:',
        Explain4: '疑わしい保有アドレス数:',
        positionTh1: 'ランク',
        positionTh2: 'アドレス',
        positionTh3: '保有割合',
        positionTh4: '数量',
        positionTh5: '24時間変動',
        positionTh6: 'ブロック情報',
        financeType1: 'トップバイヤー',
        financeType2: 'トップセラー',
        financeTh1buy: '純買い',
        financeTh1sell: '純売り',
        financeTh2buy: '買い金額($)',
        financeTh2sell: '売り金額($)',
        financeTh3: 'ユーザー',
        addTrace: '現在のアドレスを追跡しますか？',
        addTraceSuccess: '追加成功！',
    },
    market: {
        tabs1: '人気',
        tabs2: '上昇率',
        tabs3: '下落率',
        tabs4: '新しいコイン',
        tabs5: '急騰',
        tabs6: '時価総額',
        tabs7: '取引額',
        popularListTh0: '番号',
        popularListTh1: '通貨',
        popularListTh2: '最新価格',
        popularListTh3: '24H上昇率',
        popularListTh4: '24H取引量',
        popularListTh5: '24H取引額',
        popularListTh6: '流通時価総額',
        popularListTh7: '上場時間',
    },
    platform: {
        tab1: 'グローバル取引所資産ランキング',
        ERGlobalRankingListTh1: 'シリアルナンバー',
        ERGlobalRankingListTh2: 'プラットフォーム',
        ERGlobalRankingListTh3: '資産($)',
        ERGlobalRankingListTh4: '24H トランザクション量 ($)',
        ERGlobalRankingListTh5: '24時間のアップダウン',
        ERGlobalRankingListTh6: '公式ウェブサイト',
    },
    publicChain: {
        tableTh1: 'ペア',
        tableTh2: '価格/取引高', 
        tableTh3: '価格変動/時価総額',
        tableTh4: '取引回数',
        tableTh5: '保有数',
        tableTh6: '流動性/時間'
    },
    inscription: {
        typeAll: '全て',
        tableTh1: 'トークン名',
        tableTh2: 'ホルダー',
        tableTh3: 'トランザクションの合計数',
    },
    burst: {
        title6: '清算地図',
        currentPrice: '現在の価格：',
        liquidationTip1: '累計マルチシングル清算強度',
        liquidationTip2: '積算空単清算強度',
        liquidationTip3: '10 xレバー',
        liquidationTip4: '25 xレバー',
        liquidationTip5: '50 xレバー',
        liquidationTip6: '100 xレバー',
        title1: '清算ヒートマップ',
        heatmapTop: '3 つの主要な取引所 Binance、Huobi、OKX からの包括的なデータ、{0}USDT 清算の最大点は {1} 付近にあり、清算価値は {2}USDT です。資本リスクに注意してください。',
        heatmapDetailsBtn: '詳細',
        heatmapKLine1: 'k線',
        heatmapKLine2: '清算強度',
        heatmapTip1: '価格',
        heatmapTip2: '清算強度',
        kLineTip1: '始値',
        kLineTip2: '終値',
        kLineTip3: '最高価格',
        kLineTip4: '最低価格',
        noLogin: '右上をクリックしてログインすると、ログイン後にヒートマップが表示されます',
        title2: '清算データ',
        topBlockH41: '4H清算',
        topBlockH42: '12H清算',
        topBlockH43: '24時間清算',
        topBlockP1: '清算限度額',
        topBlockP2: 'ロングオーダーの割合',
        title3: '24H清算ランキング',
        rankingTh1: '交換',
        rankingTh2: '通貨',
        rankingTh3: '清算米ドル',
        rankingTh4: '米ドルロング',
        rankingTh5: '空の注文USD',
        title4: '各通貨の清算統計',
        title5: 'ネットワーク全体のすべての取引所で清算されたポジションの割合',
        burstStatisticsHistoryTitle: '通貨流動化履歴統計情報',
        burstStatisticsHistoryTh1: '通貨',
        burstStatisticsHistoryTh2: '長期注文の清算',
        burstStatisticsHistoryTh3: '短期注文清算',
        burstStatisticsHistoryTh4: '時間',
        heatmapDetailsTitle: '清算ヒートマップデータ',
        heatmapDetailsList1Top: 'ヌル',
        heatmapDetailsList1Bottom: '多くの',
        heatmapDetailsList1: '方向',
        heatmapDetailsList2: '価格',
        heatmapDetailsList3: '清算',
    },
    smartMoney: {
        typeTitle1: 'トップ 100 高頻度取引',
        typMsg1: '大手パブリックチェーン8社の包括利益・利回り上位100社',
        typeTitle2: 'セレブのスマートマネー',
        typMsg2: '世界的な有名人/パブリックチェーン創設者/有名機関のアドレス追跡',
        typeTitle3: 'レベル 1 スマートマネー',
        typMsg3: '発行市場でより高い/安定した収益をもたらすスマートマネー',
        typeTitle4: 'カスタムスマートマネー',
        typMsg4: 'ユーザーが追加したウォレットアドレスを追跡',
    },
    smartMoneyTop100: {
        topTip: '過去30日間の主要DEXの総合分析データ。バランスはあくまで参考です！ ',
        sort: 'シリアルナンバー',
        address: '住所',
        amountUsd: 'バランス',
        floatProfit: 'フローティング',
        floatProfitPercent: '変動利益率',
        profit: '利益',
        profitPercent: '利益率',
        collectTo: '集める',
        collectCancel: 'お気に入りをキャンセル',
        noLogin: 'ログイン後、世界で最も収益の高いスマート マネーのトップ 100 を表示および追跡できます。',
        toLogin: 'ログインに移動',
    },
    smartMoneyStar: {
        th1: '名前：',
        th2: '住所：',
        th3: '時間：',
    },
    smartMoneyOneLevel: {
        th1: '住所：',
        th2: '時間：',
    },
    smartMoneyCustom: {
        sort: 'シリアルナンバー',
        name: '名前',
        address: '住所',
        time: '時間',
        addNameRules: '名前を入力してください',
        addAddressRules: '住所を入力してください',
        addConfirm: '確認する',
        addSuccess: '正常に追加されました！',
        addBtn: 'カスタムを追加',
        delBtn: '消去',
        delSuccess: '無事に削除されました！',
    },
    smartMoneyDetails: {
        type1: 'DEX取引',
        queryTokenAll: '全て',
        dexAddress: '住所：',
        dexHash: 'トランザクションハッシュ:',
        dexChainName: 'チェーン名:',
        dexTransactionAmount: 'トランザクション値:',
        dexTrackerIn: '契約への転送:',
        dexTrackerOut: '契約の譲渡:',
        dexTrackerType: '取引方向:',
        dexTrackerTypeCon: '{0}{1} は {2}{3} に変換されます',
        dexTransactionTime: '取引時間:',
        type2: '普通転送',
        ordinaryHash: 'トランザクションハッシュ:',
        ordinaryTime: '時間：',
        ordinaryFrom: '送信者のアドレス:',
        ordinaryTo: '受信者のアドレス:',
        ordinarySymbol: '通貨名:',
        ordinaryAmount: '転送数量:',
    },
    manyEmpty: {
        title1: 'グローバル口座のロングショート比率',
        title2: 'トップアカウントのロングショート比率',
        title3: '上位口座保有のロングとショートの比率',
        progress1: '長さ：',
        progress2: '短い：',
        tableTh1: '交換',
        tableTh2: 'ロングショート比率',
        tableTh3: 'ロングポジションの割合',
        tableTh4: 'ショートシェア',
    },
    whale: {
        holdingsTitle: 'グレースケール位置リスト',
        holdingsTitle2: '更新時間:',
        holdingsTh1: '位置の変更',
        holdingsTh1_1: '1日',
        holdingsTh1_2: '7日間',
        holdingsTh1_3: '30日',
        holdingsTh2: 'プレミアム料金',
        holdingsTh3: '通貨保有量',
        holdingsTh4: '位置の値',
        contractTitle: '契約ポジションの合計',
        contractTh1: '交換',
        contractTh2: '位置の値($)',
        contractTh3: 'ポジション数量',
        contractTh4: '15分変更',
        contractTh5: '1日の変更',
        exchangeTitle: '為替残高リスト',
        exchangeTh1: '交換',
        exchangeTh2: 'ウォレットの数',
        exchangeTh3: '24時間変更',
        exchangeTh4: '変化の7日間',
        exchangeTh5: '30日間の変化',
        statistics1: '時価総額の合計:',
        statistics2: '24時間取引高:',
        statistics3: '24 時間以内の最高値:',
        listRight1: '時間',
        listRight2: '転送アドレス',
        listRight3: '転送アドレス',
        listRight4: '送金額',
    },
    rate: {
        newTitle: '為替現在の調達レート一覧',
        newTableTh1: '通貨',
        newTableTd1: '予測レート',
        oldTableTh1: '交換',
        oldTableTh2: '現在のレート',
        oldTableTh3: '最大レート',
        oldTableTh4: '最低レート',
        oldTableTh5: '更新時間',
    },
    consult: {
        nav1: 'ニュース',
        nav2: '発表',
        nav3: 'ニュース',
        detailsTime: '時間',
        detailsBack: '戻る',
        details: '詳細',
    },
    application: {
        nav1: '応用',
        nav2: '財布',
        nav3: '社会的接触',
        visit: '開く',
        empty: 'まだありません',
        download: 'ダウンロード',
        register: '登録する'
    },
    userSignIn: {
        alreadySignIn: '{0} 日間チェックインしました',
        signInBtn: '今すぐサインインしてください',
        tip1: 'プラットフォームを {0} 分間閲覧すると、サインイン特典を受け取ることができます',
        tip2: '(視聴時間は {0} 分 {1} 秒)',
        success: 'サインインに成功しました！',
        recordTitle: 'サインイン記録',
        recordListContent: '時間：',
    },
    userSignInRecord: {
        title: 'ウォレットの詳細',
        selectAll: '全て',
        typeSelect1: 'サインイン特典',
        typeSelect2: '直接プロモーション特典',
        typeSelect3: 'チームの報酬',
        typeSelect4: '現金引き出し控除を申請する',
        typeSelect5: 'システム拒否の増加',
        th1: 'タイプ',
        th2: '量',
        th3: '時間',
    },
    userWithdrawal: {
        titleTip: '出金アドレスはTRON（TRC-20）チェーンのウォレットアドレスでなければなりません。\'他のチェーンのウォレットアドレスを入力すると、永久的な損失が発生し、回復不能になります。 ',
        withdrawalAddress: 'あなたの出金アドレス:',
        inputWithdrawalAddress: '出金アドレスを入力してください',
        number: '量',
        inputNumber: '数量を入力してください',
        inputNumberErr: '残高不足',
        balance: 'バランス',
        actualReceipt: '実際の到着:',
        gas: '手数料:',
        tip: '最低出金は {0}USDT で、出金手数料は {1}% です。 ',
        confirm: 'もちろん',
        explain: 'オンライン取引には 0 ～ 2 時間かかります。ネットワーク確認は含まれません',
        submitSuccess: '提出が成功しました'
    },
    userWithdrawalRecord: {
        title: '貨幣引出記録',
        list1: '住所',
        list2: 'ネットワーク',
        list3: '通貨＃ツウカ＃',
        list4: '数量',
        list5: '手数料',
        list6: 'ステータス',
        list7: '時間',
        status0: '審査待ち',
        status1: '合格',
        status2: '断る',
    },
    userContractCheck: {
        enterPlaceholder: '契約住所を入力してください',
        enterBtn: '診る',
        riskAssessment: 'リスクアセスメント',
        riskInspection: 'リスクチェック',
        checkNFT1: ['悪意のない NFT', '悪意のある NFT'],
        checkNFT2: ['オープンソースではない', 'オープンソース'],
        checkNFT3: ['代理店なしの契約', '代理店との契約'],
        checkNFT4: ['未検証', '検証済み'],
        checkNFT5: ['有名で信頼できる NFT ではない', '有名で信頼できる NFT'],
        checkToken1: ['取引上限額またはトークン最大ポジションを変更する機能はありません', '取引上限額またはトークン最大ポジションを変更する機能はあります'],
        checkToken2: ['所有権は回復できません', '所有権は回復できます'],
        checkToken3: ['契約には隠れた所有者がいません', '契約には隠れた所有者がいます'],
        checkToken4: ['単一アドレスの最大取引量または最大位置を制限する機能はありません', '最大取引量または単一アドレスの最大位置を制限する機能はあります'],
        checkToken5: ['トークンはハニーポットではありません', 'トークンはハニーポットです'],
        checkToken6: ['トークンは分散型取引所では取引できません', 'トークンは分散型取引所では取引できます'],
        checkToken7: ['契約にはトークンを鋳造する能力がありません', '契約にはトークンを鋳造する能力があります'],
        checkToken8: ['オープンソースではない', 'オープンソース'],
        checkToken9: ['エージェントではありません', 'エージェントです'],
        checkToken10: ['契約所有者はトークン所有者の残高を変更できません', '契約所有者はトークン所有者の残高を変更できます'],
        checkToken11: ['割り当てられた住所ごとに異なる税率を設定することはできません', '割り当てられた住所ごとに異なる税率を設定することができます'],
        checkToken12: ['契約は自滅することはできない', '契約は自滅する可能性がある'],
        checkToken13: ['契約にはトランザクション クーリング メカニズムがありません', 'コントラクトにはトランザクション クーリング メカニズムがあります'],
        checkToken14: ['トークンコントラクトを通じて取引を一時停止することはできません', 'トークンコントラクトを通じて取引を一時停止することができます'],
        checkToken15: ['このトークンは有名で信頼できるトークンではありません', 'このトークンは有名で信頼できるトークンです'],
        botToken1: '所有者のアドレス',
        botToken2: 'オーナーの残高',
        botToken3: '所有者が保有するトークンの割合',
        botToken4: '供給量',
        botNFT1: '総取引量',
        botNFT2: '保有者数',
        botNFT3: '最高価格',
        botNFT4: '24時間平均価格',
        botNFT5: '24時間最低価格',
    },
    userCollect: {
        title: '集める',
        sort: 'シリアルナンバー',
        address: '住所',
        amountUsd: 'バランス',
        floatProfit: 'フローティング',
        floatProfitPercent: '変動利益率',
        profit: '利益',
        profitPercent: '利益率',
        cancel: 'お気に入りをキャンセル',
        cancelSuccess: 'キャンセル成功しました！',
    },
    userTrace: {
        title: '追跡',
        th1: 'シリアルナンバー',
        th2: 'パブリックチェーン名',
        th3: 'トークン名',
        th4: '住所',
        del: '消去',
        delSuccess: '無事に削除されました！',
    },
    userTeam: {
        title: 'チーム',
        topInfo1: '直進人数',
        topInfo2: 'チーム人数',
        topInfoUnit: '人',
        th1: 'ユーザー名:',
        th2: '登録時間:',
    },
    userTool: {
        tool1: 'BTC 企業の立場',
        tool2: 'センチメントインデックス',
        tool3: 'メントウグーモニタリング',
        tool4: '店頭価格',
        tool5: '外部ディスクデータ',
        tool6: '大規模トレーダーはポジションを増やす',
        tool7: '大規模トレーダーはポジションを減らす',
        tool8: 'ステーブルコイン',
        tool9: 'ブロックチェーンブラウザ',
    },
    userToolCompanyHoldings: {
        title: 'グローバル企業のBTC保有データ',
        globalDataT1: 'BTC持株会社',
        globalDataD1: '家',
        globalDataT2: '会社の総ポジション',
        globalDataD2: '過去 7 日間の変更:',
        globalDataT3: 'ポジションの合計値',
        globalDataD3: '過去 7 日間の変更:',
        globalDataT4: 'ポジションはBTC市場価値の合計を占めます',
        globalDataD4: '7 日前の割合:',
        th1: '会社名',
        th2: '位置の値($)',
        th3: 'BTC 市場価値の説明',
        th4: 'ポジションBTC',
        th5: '過去 7 日間のポジションの変化',
        th6: '総保有コスト',
        th7: '平均コスト($)',
    },
    userToolSentimentIndex: {
        title1: 'パニックと貪欲指数',
        title1_1: 'BTCと重要な主流通貨のパニックと強欲指数',
        gauge1: '極度のパニック',
        gauge2: 'パニック',
        gauge3: '中性',
        gauge4: 'よく深い',
        gauge5: '極度の貪欲さ',
        title2: '履歴インデックス',
    },
    userToolMTGoxMonitor: {
        time: '更新時間:',
        title1: 'メントウグー (MTGox) BTC コールドウォレット',
        topLabel1: '元々保有していたBTCの合計額',
        topLabel1Span: '元の値',
        topLabel2: '残りの合計BTC',
        topLabel2Span: '現在値',
        topLabel3: '保有BTCの変化',
        title2: 'BTCコールドウォレットチェーンの送金記録',
        th1: '取引時間',
        th2: 'コールドウォレットアドレス',
        th3: '送金BTC額',
    },
    userToolOutsidePrice: {
        th1: 'トークン名',
        th2: '交換',
        th3: '平均取引価格',
        th4: 'プレミアム',
    },
    userToolOutsideDisk: {
        itemTitleSpan: '更新',
        itemTitle2: '開店時間:',
        itemInfo1: '昨日の収穫',
        itemInfo2: '今日',
        itemInfo3: '今日の取引高',
        itemInfo4: '今日の最高値',
        itemInfo5: '今日の最低値',
        itemInfo6: '過去1年間で最高額',
        itemInfo7: '過去1年間で最低',
    },
    userToolLargeIncrease: {
        title: '大規模トレーダーはポジションを増やす',
        titleMsg: '異なる期間の複数または単一の通貨について、選択した期間における通貨の上昇と下降を自動的に計算します',
        th1: '通貨',
        th2: '24時間のアップダウン',
        th3: '24H位置比率',
        th4: '週次ポジション比率',
        th5: '月間保有比率',
        th6: 'グローバルインデックス($)',
        th7: '上位 10 位の割合',
        th8: '上位 20 位の割合',
        th9: '上位 50 位の割合',
        th10: '上位 100 位の割合',
    },
    userToolLargeDecrease: {
        title: '大規模トレーダーはポジションを減らす',
        titleMsg: '異なる期間の複数または単一の通貨について、選択した期間における通貨の上昇と下降を自動的に計算します',
        th1: '通貨',
        th2: '24時間のアップダウン',
        th3: '24H位置比率',
        th4: '週次ポジション比率',
        th5: '月間保有比率',
        th6: 'グローバルインデックス($)',
        th7: '上位 10 位の割合',
        th8: '上位 20 位の割合',
        th9: '上位 50 位の割合',
        th10: '上位 100 位の割合',
    },
    userToolStableCoin: {
        tab1: 'USDT相場',
        UsdTopInfo1: 'USDT OTC 平均価格',
        UsdTopInfo2: '米ドル為替レート',
        UsdTopInfo3: 'USDT プレミアム レート',
        UsdTitleSub1: 'USDT関連指数トレンド',
        UsdTitleSub2: 'USDTプレミアム関連のトレンド',
        UsdQuery1: '7日間',
        UsdQuery2: '30日',
        tab2: '関連するステーブルコイン',
        relatedTitleSub1: 'ステーブルコインの概要',
        relatedTopTh1: '通貨',
        relatedTopTh2: 'オフサイト平均価格 ($)',
        relatedTopTh3: 'プレミアム料金',
        relatedTopTh4: '現在の循環',
        relatedTopTh5: '流通市場価値 ($)',
        relatedQuery1: '30日',
        relatedQuery2: 'ほぼ1年',
        relatedTitleSub2: 'ステーブルコインの流通',
        relatedTitleSub3: 'ステーブルコインの流通割合',
        relatedTitleSub4: 'ステーブルコインチェーンの問題',
        relatedBottomTh1: '時間',
        relatedBottomTh2: 'コイン/メインネット',
        relatedBottomTh3: '発行番号',
        relatedBottomTh3_1: '追加発行',
        relatedBottomTh3_2: '破壊する',
        relatedBottomTh4: 'トランザクションハッシュ',
    },
    userToolBlockChainBrowser: {
        title: 'ブロックチェーンエクスプローラー'
    },
    bindingApi: {
        bindBtn: 'バインド API',
        tip: '取引所のAPI作成にはIPをバインドする必要があります',
        listTitle: 'バインディング リスト',
        list1: 'バインドを解除',
        list2: '利用可能な残高:',
        enterBourse: '取引所を選択:',
        enterNotes: 'メモ:',
        enterBourseErr: '取引所を選択してください',
        enterApiKeyErr: 'Api key と入力してください',
        enterSecretKeyErr: 'Secret key と入力してください',
        enterPassphraseErr: 'PassPhrase と入力してください(OKX必須)',
        enterNotesErr: 'メモを入力してください',
        bindSubmit: '送信',
        bindSuccess: 'バインド成功',
        unBindSuccess: 'バインド解除に成功しました'
    },
    hitNewRobot: {
        top1: 'テクノロジーの未来をリードするスマートな時代',
        top2: '新しいロボットは9月30日に正式に発売されます',
        topBtn: 'ゲームのルール>>',
        hitNewTitle: '新しいヒットリストを交換',
        hitSelTitle: 'ブロックを選択してください',
        hitNewlistTh1: 'トークン情報',
        hitNewlistTh2: 'トークン価格',
        hitNewlistTh3: '初期流動性',
        hitNewlistTh4: '総流動資金',
        hitNewlistTh5: 'プール金額',
        hitNewlistTh6: 'プール',
        hitNewlistTh7: '残り',
        hitNewlistTh8: '上場以来',
        createBtn: '作成',
        createTitle: 'ロボットの作成',
        createLabel1: 'Exchange名:',
        createLabel2: '通貨ペアの名前:',
        createLabel3: 'リスト時間:',
        createLabel7: '使用可能残高：',
        createLabel4: '購入予定数量:',
        createLabel5: '推定購入価格:',
        createLabel6: '買い占め時間：',
        createLabel4Err: '推定購入数量を入力してください',
        createLabel5Err: '推定購入価格を入力してください',
        createLabel6Err: '買占め時間を選択してください',
        createTip: '購入価値は>=10 USDT',
        createSuccess: '作成に成功しました! ',
        robotTitle: 'ロボットリスト',
        robotListStatus1: '実行予定',
        robotListStatus2: '終了',
        robotListBinanceStatus1: '請求書作成に成功しました',
        robotListBinanceStatus2: '請求に失敗しました',
        robotList1: '実行時間:',
        robotList2: 'ロボットをキャンセル',
        robotList3: 'コインペア',
        robotList4: '価格',
        robotList5: '数量',
        robotCancel: 'キャンセル成功',
    },
    hitNewRobotRule: {
        title: 'リターンマッチ',
        h2_1: '主な利点：',
        label1_1: '効率的なアルゴリズム：',
        label1_2: '深い統合：',
        label1_3: 'ビッグデータ処理：',
        label1_4: '賢い戦略：',
        label1_5: '安全：',
        label1_6: '自動取引：',
        label1_7: 'エクスペリエンスの最適化：',
        p1_1: '内蔵の効率的なアルゴリズム、ミリ秒レベルの取引決定、市場ダイナミクスの正確な把握。',
        p1_2: 'Binance、HTX、OKX などの主流の取引所 API を統合して、包括的で正確なデータを確保します。',
        p1_3: 'Apache Kafka と Flink テクノロジーを利用して、リアルタイムで市場データを収集および処理します。',
        p1_4: 'TensorFlow または PyTorch フレームワークと組み合わせて、履歴データとトレンドを使用して新しい戦略を最適化します。。',
        p1_5: '分散アーキテクチャと複数の暗号化テクノロジーにより、ユーザー データとトランザクションのセキュリティを確保します。',
        p1_6: '将来的には、DEX自動取引と効率的な資産管理を実現するために、スマートコントラクトとクロスチェーン技術を検討していきます。。',
        p1_7: 'インターフェイスとインタラクションのデザインを継続的に最適化し、直感的なデータ視覚化ツールを提供し、ユーザー エクスペリエンスを向上させます。。',
        h2_2: 'メンバーシップのアップグレード基準：',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '3名を直接推薦し、チームは100名に到達。',
        p2_2: '5人を直接推薦し、チームは200人に到達。',
        p2_3: '直接昇格したのは 5 人で、そのうち 2 人が v2 に到達しました。',
        p2_4: '直接昇格したのは 5 名で、そのうち 2 名が v3 に到達しました。',
        p2_5: '直接推薦した 5 人のうち 2 人が v4 に到達。',
        p2_6: '直接昇格したのは 5 人で、そのうち 2 人が v5 に到達しました。',
        p2_7: '直接昇格は5名、うち2名がv6に到達。',
        h2_3: 'ロボットの流通基準：',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: 'ロボットを1体入手。',
        p3_2: 'ロボットを3体入手。',
        p3_3: 'ロボットを5体入手。',
        p3_4: 'ロボットを6体入手。',
        p3_5: 'ロボットを7体入手。',
        p3_6: 'ロボットを9体入手。',
        p3_7: '10 体のロボットを獲得し、さらに 5 体をプレゼント、合計 15 体のロボットになります。',
        h2_4: 'ロボットの効果的な動作条件：',
        label4_1: '継続的なチェックイン：',
        label4_2: '発動条件：',
        label4_3: 'チェックインが中断されました：',
        p4_1: 'メンバーはロボットが効果的に動作していることを確認するために毎日チェックインし続ける必要があります。',
        p4_2: '継続的にサインインしているメンバーのみが新しいサービスをアクティブ化できます。',
        p4_3: '当日にサインを見逃した場合、翌日には新しいロボットの動作が停止し、サインインが再開された翌日の0:00に自動的に起動します。。',
        h2_5: '要約する：',
        p5: 'このプラットフォームのデジタル通貨新規作成ロボットモジュールは、効率的なアルゴリズムとインテリジェントな戦略を通じて、自動化された効率的かつ安全な新規作成サービスを会員に提供します。テクノロジーの継続的な進歩により、当社は今後もユーザーエクスペリエンスを最適化し、より多様な新しいオプションを拡大し、会員の資産価値の向上を支援していきます。。'
    },
    invite: {
        title: '友達を招待する',
        info1: '友達を登録/チームに招待する',
        info2: 'ロボット/プロモーション特典を開封するチャンスがあります',
        info3: 'こんにちは！TokenTrend プラットフォームへようこそ',
        info4: '通貨サークルの初心者向けに特別にカスタマイズされた新しいツールは、ワンクリックで使用できます',
        btn: '招待リンクをコピー'
    },
    hyperliquid: {
        searchPlaceholder: 'ウォレットアドレスを入力してポジションを検索...',
        searchBtn: '検索',
        title: 'クジラポジション監視',
        dataCount: '大口ポジション {0} 件',
        long: 'ロング',
        short: 'ショート',
        cross: 'クロス',
        isolated: '隔離',
        positionValue: 'ポジション価値',
        positionSize: 'ポジションサイズ',
        entryPrice: '建玉価格',
        markPrice: 'マーク価格',
        unrealizedPnl: '未実現損益',
        noData: 'データなし',
        enterAddress: 'ウォレットアドレスを入力してください',
        enterValidAddress: '有効なウォレットアドレスを入力してください',
        copyAddress: 'アドレスをコピー',
        whale: 'クジラ',
        explorer: 'エクスプローラー',
        accountTotalValue: '口座総額',
        perpetual: '無期限',
        freeMarginAvailable: '利用可能証拠金',
        withdrawable: '出金可能',
        totalPositionValue: 'ポジション総額',
        leverageRatio: 'レバレッジ比率',
        marginUsed: '使用証拠金',
        usedRatio: '使用率',
        perpTotalValue: '無期限ポジション総額',
        positionsCount: '{0} ポジション',
        avgMarginUsedRatio: '平均証拠金使用率',
        directionBias: '方向バイアス',
        longExposure: 'ロングエクスポージャー',
        shortExposure: 'ショートエクスポージャー',
        positionDistribution: 'ポジション分布',
        longValue: 'ロング価値',
        shortValue: 'ショート価値',
        roe: 'ROE',
        upnl: '未実現損益',
        perpPositions: '無期限ポジション ({0})',
        symbol: '銘柄',
        entryAvgPrice: '平均建玉価格',
        margin: '証拠金',
        fundingCost: '資金調達コスト',
        noPositions: 'ポジションなし',
        userAddressRequired: 'ユーザーアドレスは必須です',
        addressCopied: 'アドレスをコピーしました',
        copyFailed: 'コピーに失敗しました',
        bullish: '強気',
        bearish: '弱気',
        neutral: '中立'
    }
}